import { useState } from 'react';
import PageHeader from '../../../Layout/PageHeader';
import CycleCountByItemFormStructure from '../../../Shared/Forms/CycleCountByItemFormStructure';
import CommonModal from '../../../Components/Modals/CommonModal';
import FormSelect from '../../../Components/FormTag/FormSelect';
import { assignUser } from '../../../Data/dropdownDataList';
import { useForm } from 'react-hook-form';
import { Search } from 'react-bootstrap-icons';
import ScheduleCountByLocationModal from './ScheduleCountByLocationModal';
import Select, { SingleValue } from 'react-select';
import { cycleCountData } from '../../../Data/cycleCountData';
import MultipleCheckboxDropdown from '../../../Components/MultipleCheckboxDropdown';
import FormButton from '../../../Components/Buttons/FormButton';
import { useNavigate } from "react-router-dom";

function CycleCountByLocation() {
  const navigate = useNavigate();
  const pageName = `Cycle Count(By Location)`;
  const [isChecked, setIsChecked] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedOperator, setSelectedOperator] = useState('equalTo');
  const [locationTypeOptions, setLocationTypeOptions] = useState(
    cycleCountData.locationType
  );

  const handleShow = () => setShow(!show);

  const {
    control,
    formState: { errors },
  } = useForm<typeof assignUser>({
    defaultValues: assignUser,
  });

  const handleOperatorChange = (selectedOption: SingleValue<{ value: string; label: string }> | null) => {
    if (selectedOption) {
      setSelectedOperator(selectedOption.value);
    } else {
      setSelectedOperator('equalTo');
    }
  };

  const inputs = [
    <div className='col'>
      <label className="fw-medium">Created Date *</label>
      <div className="mt-1">
        <input
          tabIndex={1}
          maxLength={50}
          type="date"
          name="createdDate"
          className="form-control"
          required
        />
      </div>
    </div>,
    <div className='col'>
      <label className="fw-medium">Assigned to</label>
      <div className="mt-1">
        <FormSelect
          name="assignUser"
          tabIndex={1}
          control={control}
          optionList={assignUser}
          required={true}
          className="form-control p-0"
          placeholder={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Search style={{ marginRight: '5px' }} />
              Search
            </div>
          }
          isSearchable={true}
        />
      </div>
    </div>,
    <>
      <label className="fw-medium">Schedule Count</label>
      <div className="form-check form-switch sidebar-toggler py-2">
        <input
          className="form-check-input toggle-button-size mt-2"
          type="checkbox"
          role="switch"
          id="flexSwitchCheckChecked"
          checked={isChecked}
          onClick={handleShow}
          onChange={() => {
            setIsChecked(!isChecked);
            if (!isChecked) {
              setShow(true);
            } else {
              setShow(false);
            }
          }}
        />
        {show && (
          <CommonModal
            handleClose={handleShow}
            show={show}
            heading="Schedule Count"
            content={<ScheduleCountByLocationModal handleClose={handleShow} />}
            modalSize="modal-lg"
            footerButtonsActive={false}
            customClassNameForBody="schedule-count-pop-up"
          />
        )}
      </div>
    </>,
  ];

  return (
    <>
      <PageHeader
        addUrl="/inventory/counts/cycle-count"
        listUrl="/inventory/counts/cycle-count"
        viewType={true}
        isHistoryEnabled={true}
      />
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="my-2 bg-white rounded py-1 px-2 ">
        <CycleCountByItemFormStructure inputFields={inputs} />
      </div>
      <div className="mb-2 bg-white rounded py-1 px-2 h-100">
        <div className='text-end p-3 text-grey'>No. of Locations:</div>
        <div className="d-flex justify-content-start gap-2 px-4 pb-4">
          <div className="col-3 count-multiselect">
            <label className="fw-medium">Zone</label>
            <MultipleCheckboxDropdown
              control={control}
              name="zoneDropDown"
              className="form-select cursor-pointer dropdown multi-select-input mt-1"
              optionsList={cycleCountData.zoneDropDown}
              placeholder="Search Here"
              required={true}
            />
          </div>
          <div className="col-3 count-multiselect">
            <label className="fw-medium">Location Type</label>
            <MultipleCheckboxDropdown
              control={control}
              name="locationType"
              className="form-select cursor-pointer dropdown multi-select-input mt-1"
              optionsList={[{ value: 'all', label: 'Select All', isAll: true }, ...locationTypeOptions]}
              placeholder="Search Here"
              required={true}
            />
          </div>
          <div className="col-3">
            <label className="fw-medium">Operator</label>
            <Select
              name="operator"
              options={cycleCountData.operator}
              className="basic-multi-select input-border-style mt-1"
              classNamePrefix="select"
              value={cycleCountData.operator.find(i => i.value === selectedOperator)}
              onChange={handleOperatorChange}
            />
          </div>
          <div className="col-3 d-flex">
            <div className='col-12'>
              <label className="fw-medium">Value</label>
              <FormSelect
                name="value_from"
                tabIndex={1}
                control={control}
                optionList={cycleCountData.value_from}
                required={true}
                className="basic-multi-select mt-1"
                placeholder="Select"
                isSearchable={true}
              />
            </div>
            {selectedOperator === 'between' ? (
              <>
                <div className="middle-ware px-2">
                  <label></label>
                  <div className='mt-2'>-</div>
                </div>
                <div className='col-6'>
                  <label></label>
                  <FormSelect
                    name="value_to"
                    tabIndex={1}
                    control={control}
                    optionList={cycleCountData.value_to}
                    required={true}
                    className="basic-multi-select"
                    placeholder="Select"
                    isSearchable={true}
                  />
                </div>
              </>
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </div>
      <div className="mt-auto bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={3}
            className="sph-btn me-4"
            handleClick={() => {
              navigate("/inventory/counts/cycle-count")
            }}
          >
            Submit
          </FormButton>
          <FormButton
            tabIndex={4}
            className="sph-btn sph-shift me-4"
            handleClick={() => { navigate("/inventory/counts/cycle-count") }}
          >
            Cancel
          </FormButton>
        </div>
      </div>
    </>
  );
}

export default CycleCountByLocation;
